import { Modal, Result, Button } from 'antd';
import { useIntl } from 'react-intl';
import { VerificationStatus } from 'entities/user/model/types';
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  ClockCircleTwoTone,
} from '@ant-design/icons';

type Props = {
  open: boolean;
  onClose: () => void;
  onAction?: () => void;
  actionText?: string;
  status: VerificationStatus;
};

const VerificationStatusModal: React.FC<Props> = ({
  open,
  onClose,
  onAction,
  actionText,
  status,
}) => {
  const { formatMessage: t } = useIntl();

  const getModalContent = () => {
    switch (status) {
      case VerificationStatus.Rejected:
        return {
          icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
          title: <strong>{t({ id: 'emi.verification.rejected.title' })}</strong>,
          subTitle: t({ id: 'emi.verification.rejected.description' }),
        };
      case VerificationStatus.Pending:
        return {
          icon: <ClockCircleTwoTone twoToneColor="#CCCCCC" />,
          title: <strong>{t({ id: 'emi.verification.pending.title' })}</strong>,
          subTitle: t({ id: 'emi.verification.pending.description' }),
        };
      case VerificationStatus.Completed:
      case VerificationStatus.Verified:
        return {
          icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
          title: <strong>{t({ id: 'emi.verification.verified.title' })}</strong>,
          subTitle: t({ id: 'emi.verification.verified.description' }),
        };
      default:
        return {
          icon: null,
          title: '',
          subTitle: '',
        };
    }
  };

  const { icon, title, subTitle } = getModalContent();

  return (
    <Modal
      footer={null}
      open={open}
      onCancel={onClose}
      centered
      styles={{
        body: {
          padding: '8px'
        }
      }}
      style={{
        borderRadius: 16,
      }}
    >
      <Result
        icon={icon}
        title={title}
        subTitle={subTitle}
        style={{ paddingTop: 16, paddingBottom: 0 }}
        extra={
          <Button
            type="primary"
            onClick={onAction || onClose}
            style={{
              backgroundColor: 'black',
              borderColor: 'black',
              width: '100%',
            }}
          >
            {actionText || t({ id: 'button.simple.ok' })}
          </Button>
        }
      />
    </Modal>
  );
};

export default VerificationStatusModal;
